module.exports = __webpack_public_path__ + "static/bf_dungeon-b8a1e194371482480eba6f0a1dbeed6c.png";